<div id="overlay"> 
    <div class="overlay-message"></div>
</div>
<mat-form-field  fxFlex="0 0 100%" appearance="outline" class="dhl-borderless-field" [formGroup]="frmGroup" color="accent" [ngClass]="{'exportToCSV': configData.exportToCSV}">
    <div>
        <input matInput [hidden]="true" type="text" autocomplete="off" type="text">
    </div>    
    <button *ngIf="!configData.exportToCSV" mat-button color="warn" [disabled]="!frmGroup.get(this.configData.name).enabled" (click)="downloadFile()">
        <mat-icon>{{configData.matIcon}}</mat-icon>
        <span>&nbsp;&nbsp;&nbsp; {{configData.label}}</span>
    </button>

    <!-- CP-3513 -start- export button- export orders to csv -->
    <button *ngIf="configData.exportToCSV" class="buttons-textwithicon" 
     color="warn" [disabled]="!frmGroup.get(this.configData.name).enabled" (click)="downloadFile()">

        <img class="default-icon" src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,2050,18,18))" 
            type="image/svg+xml" style = "width: 18px; height: 18px; object-fit: contain; margin-bottom:-21px;"> 
        <img class="active-icon" src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,2080,18,18))" 
            type="image/svg+xml" style = "width: 18px; height: 18px; object-fit: contain; margin-bottom:-21px;"> 
        
        <span> {{configData.label}} </span>

    </button>
    <!-- Cp-3513 -end -->

</mat-form-field>
<app-progress-spinner-v2 *ngIf="isLoading"></app-progress-spinner-v2>  